import { render, staticRenderFns } from "./DeactivateReasonSoldOrRented.vue?vue&type=template&id=6b7dc675&"
import script from "./DeactivateReasonSoldOrRented.vue?vue&type=script&lang=ts&"
export * from "./DeactivateReasonSoldOrRented.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports